import { apiRequest, HttpError, publicWebRoutes } from '@shared'
import type { PublicActionResponse, ServiceFormRequest } from '../../shared/types'
import { toServiceFormPayload } from '../../shared/types'

export async function submitContactUpdation(request: ServiceFormRequest): Promise<string> {
  const result = await apiRequest<PublicActionResponse>(publicWebRoutes.contactUpdate, {
    method: 'POST',
    data: toServiceFormPayload(request),
  })
  if (!result.success) {
    throw new HttpError(result.message)
  }
  return result.message
}
